import { Box, Checkbox, Collapse, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';

import { useGeneralTasksStore } from '../hooks/useGeneralTasksStore';
import { GeneralTasksFilters } from '../types/generalTasksTypes';
import { generalTaskStatusOptions } from '../utils/generalTasksConstants';

import { MultiselectFilter, TextFilter } from './generalTasksToolbarFilterComponents';

const useStyles = makeStyles(theme => ({
  container: {
    paddingtTop: theme.spacing(2),
    '& .MuiInputBase-root': {
      backgroundColor: 'white',
    },
  },
}));

export const SupportTasksToolbarFilters = observer(() => {
  const classes = useStyles();
  const [showFilters, setShowFilters] = useState(true);
  const { generalTasksStore } = useGeneralTasksStore();
  const { supportTasksStore, supportTasksGridStore } = generalTasksStore;

  const { filters } = supportTasksStore;

  const selectedFilters = [
    GeneralTasksFilters.TASK_ID,
    GeneralTasksFilters.TITLE,
    GeneralTasksFilters.STATUS,
  ];

  const refresh = () => {
    supportTasksGridStore.resetAndFetchGridData();
  };

  const applyNow = (filterName, options) => {
    supportTasksStore.setFilter(filterName, options);
    refresh();
  };

  return (
    <Box className={classes.container}>
      <Box display="flex" alignItems="center">
        <Button
          testId="show-support-filters"
          size="small"
          style={{ minWidth: 'auto' }}
          onClick={() => setShowFilters(val => !val)}
        >
          {showFilters ? <ArrowDropUp /> : <ArrowDropDown />}
        </Button>

        <Typography variant="h6">Filters</Typography>

        <Button
          testId="reset-support-filters"
          variant="text"
          size="small"
          color="primary"
          style={{ marginLeft: '16px' }}
          onClick={() => {
            supportTasksStore.resetFilters();
            refresh();
          }}
        >
          Reset Filters
        </Button>
      </Box>

      <Collapse in={showFilters}>
        <Box pt={2}>
          <Grid container spacing={2} alignItems="flex-end">
            {selectedFilters.map(filterName => {
              const value = filters?.[filterName];
              const filterProps = {
                value,
                onChange: (options: any) => {
                  supportTasksStore.setFilter(filterName as any, options);
                },
              };

              return (
                <Grid item key={filterName}>
                  {GeneralTasksFilters.STATUS === filterName && (
                    <MultiselectFilter
                      {...filterProps}
                      label="Status"
                      options={generalTaskStatusOptions}
                      onChange={(opts) => applyNow(GeneralTasksFilters.STATUS, opts)}
                    />
                  )}

                  {GeneralTasksFilters.TITLE === filterName && (
                    <TextFilter {...filterProps} label="Title" />
                  )}

                  {GeneralTasksFilters.TASK_ID === filterName && (
                    <TextFilter {...filterProps} label="Task Id" maxWidth="100px" />
                  )}
                </Grid>
              );
            })}

            <Grid item>
              <FormControlLabel
                style={{ marginRight: 0 }}
                control={
                  <Checkbox
                    data-testid="filter-show-last-30-days"
                    color="primary"
                    checked={supportTasksStore.showCompletedInLastThirtyDays}
                    onChange={(e) =>
                      supportTasksStore.setshowCompletedInLastThirtyDays(e.target.checked)
                    }
                  />
                }
                label="Show Completed in the last 30 days"
              />
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Box>
  );
});
